<template>
  <div>
    <div class="content row">
      <!-- <div class="col-12 upi-fail-msg">
        We’re experiencing a high failure rate with UPI. We suggest using an alternate payment mode if possible.
      </div> -->
      <div class="form-check-label col-12 justify-content-center">
        <p v-bind:style="[bannerPlaceHolderWithoutUpiWeb.styles]" class="upi-message text-center" 
          v-if="bannerPlaceHolderWithoutUpiWeb && Object.keys(bannerPlaceHolderWithoutUpiWeb).length">
          {{bannerPlaceHolderWithoutUpiWeb.text}}
        </p>
      </div>
      <div class="form-check-label">
        <label class="custom-radio w-100" v-for="(item, index) in this.upiOutageData" :key="index">
          <div class="waltcol026 p-2" :style="item.isOutageApplicable && item.isOutageApplicable === 'DOWN' ? `background-color: ${bannerPlaceHolderFoPayMethodDown.banner_color };` : ''">
          <div class="wal15" @click="!isDesktop && toggleTextBox(item.value)" @change="imgHighlightHandler($event)">
            <div class="left_img65">
            <div class="image-wrapper" :class="imgHighLight === item.value ? 'image-wrapper-highlight' : ''" @click="toggleTextBox(item.value)" @change="imgHighlightHandler($event)">
              <img :data-src="'data:image/png;base64,' + item.image" :alt="item.name"/>
            </div>
            <span style="width:80px; text-align:left">{{ item.name }}</span>
            </div>
            <div class="phone8898">
              <div v-if="isDesktop === true">
                <div class="num65" :class="{contactprefix: placeHolderName === 'Enter Phone No.' }" v-if="item.value === 'GOOGLEPAY'" v-show="gPaySelected">
                  <input v-if="paymentSelected === 'GOOGLEPAY'" type="number" class="form-control" :name="paymentSelected" :placeholder="placeHolderName" v-model="inputValueUser">
                  <div v-if="paymentSelected === 'GOOGLEPAY'" class="message">{{ validation.firstError('inputValueUser') }}</div>
                </div>
                <div class="num65" v-if="item.value === 'PAYTMUPI'" v-show="payTmSelected">
                  <input v-if="paymentSelected === 'PAYTMUPI'" class="form-control" :name="paymentSelected" :placeholder="placeHolderName" v-model="inputValueUser">
                  <div v-if="paymentSelected === 'PAYTMUPI'" class="message">{{ validation.firstError('inputValueUser') }}</div>
                </div>
            </div>
            <div class="radio-item" v-if="!(item.isOutageApplicable && item.isOutageApplicable === 'DOWN')">
            <input :id="item.value" @click="toggleTextBox(item.value)" @change="imgHighlightHandler($event)" name="radio" type="radio" class="custom-control-input-tapan" :value="item.value" v-model="upi.name">
            <label :for="item.value"></label>
            </div>
            </div>
            </div>
          </div>
          <div class="num65" :class="{contactprefix: placeHolderName === 'Enter Phone No.' }" v-if="isxsMobile === true && item.value === 'GOOGLEPAY'" v-show="gPaySelected">
              <input v-if="paymentSelected === 'GOOGLEPAY'" type="number" class="form-control" :name="paymentSelected" :placeholder="placeHolderName" v-model="inputValueUser">
              <div v-if="paymentSelected === 'GOOGLEPAY'" class="message">{{ validation.firstError('inputValueUser') }}</div>
          </div>
          <div class="num65"  v-if="isxsMobile === true && item.value === 'PAYTMUPI'" v-show="payTmSelected">
              <input v-if="paymentSelected === 'PAYTMUPI'" class="form-control" :name="paymentSelected" :placeholder="placeHolderName" v-model="inputValueUser">
              <div v-if="paymentSelected === 'PAYTMUPI'" class="message">{{ validation.firstError('inputValueUser') }}</div>
          </div>
          <div
            v-if="item.isOutageApplicable === 'DOWN' && bannerPlaceHolderFoPayMethodDown"
            :style="`background-color: ${bannerPlaceHolderFoPayMethodDown.banner_color };`"
          >
            <p
              class="upi-message"
              :style="`color: ${bannerPlaceHolderFoPayMethodDown.banner_text_color };`"
            >
              {{bannerPlaceHolderFoPayMethodDown.description}}
            </p>
          </div>
          <div v-if="item.isOutageApplicable === 'FLUCTUATE' && bannerPlaceHolderFoPayMethodFluctuating">
            <p class="upi-message"
              :style="`color: ${bannerPlaceHolderFoPayMethodFluctuating.banner_text_color };`"
            >
              {{bannerPlaceHolderFoPayMethodFluctuating.description}}
            </p>
          </div>
        </label>
      </div>
    </div>
    <!--<div class="form-group row text-box" v-if="paymentSelected">
      <div class="col-sm-12" :class="{error: validation.hasError('inputValueUser')}">
        <div :class="{contactprefix: placeHolderName === 'Enter Phone No.' }">
          <input v-if="paymentSelected === 'GOOGLEPAY'" type="number" class="form-control" :name="paymentSelected" :placeholder="placeHolderName" v-model="inputValueUser">
          <input v-else-if="paymentSelected === 'PAYTMUPI'" class="form-control" :name="paymentSelected" :placeholder="placeHolderName" v-model="inputValueUser">
        </div>
        <div class="message">{{ validation.firstError('inputValueUser') }}</div>
      </div>
    </div>-->
  </div>
</template>

<script>
  var $ = require('jquery')
  window.jQuery = $
  import {mapGetters} from 'vuex'
  import SimpleVueValidation from 'simple-vue-validator'
  let Validator = SimpleVueValidation.Validator
  export default {
    name: 'upiInput',
    props: ['callerComp', 'payopt'],
    components: {
    },
    data: function () {
      return {
        upi: {
          name: '<>'
        },
        toggleBox: false,
        gPaySelected: false,
        payTmSelected: false,
        paymentSelected: '',
        placeHolderName: 'Enter VPA',
        inputValueUser: '',
        upiValue: '',
        isDesktop: true,
        isxsMobile: true,
        gokwikSelected: false,
        imgHighLight: null
      }
    },
    validators: {
      inputValueUser: function (value) {
        if (this.paymentSelected === 'GOKWIKUPI') {
          return !Validator.value(value).required()
        } else if (this.paymentSelected === 'GOOGLEPAY') {
          return Validator.value(value).required().digit('Must be number.').length(10)
        } else {
          Validator.value(value).required()
        }
      }
    },
    watch: {
      payopt () {
        if (this.payopt !== 'upi') {
          this.upi.name = '<>'
          this.imgHighLight = null
        }
      }
    },
    methods: {
      toggleTextBox: function (event) {
        if (event === 'PAYTMUPI') {
          if (this.placeHolderName === 'Enter Phone No.') {
            this.inputValueUser = ''
          }
          this.gPaySelected = false
          this.payTmSelected = true
          this.gokwikSelected = false
          this.placeHolderName = 'Enter VPA'
          this.paymentSelected = event
        } else if (event === 'GOOGLEPAY') {
          if (this.placeHolderName === 'Enter VPA') {
            this.inputValueUser = ''
          }
          this.payTmSelected = false
          this.gPaySelected = true
          this.gokwikSelected = false
          this.placeHolderName = 'Enter Phone No.'
          this.paymentSelected = event
        } else if (event === 'GOKWIKUPI') {
          this.inputValueUser = ''
          this.payTmSelected = false
          this.gPaySelected = false
          this.gokwikSelected = true
          this.placeHolderName = ''
          this.paymentSelected = event
        }
        this.$parent.payopt = 'upi'
        this.$parent.setPayMethod('upi')
        let nonRadioPayArr = ['cod', 'prepaid', 'cred', 'dcc']
        if (nonRadioPayArr.indexOf(this.payopt) === -1) {
          this.$store.commit('GTAG_EVENT', {eventName: 'PAYMENT_METHOD_SELECT',
            payload: {
              type: this.$parent.getPaymentName(this.$parent.payopt),
              method: (event || 'NA')
            }}
          )
        }
      },
      getUpi: function () {
        return this.$validate().then((success) => {
          let upiObj = {}
          let { paymentSelected } = this
          if (success) {
            switch (paymentSelected) {
              case 'PAYTMUPI' :
                Object.assign(upiObj, {payment_value: paymentSelected, value: this.inputValueUser, payment_type: 'UPI'})
                break
              case 'GOOGLEPAY' :
                Object.assign(upiObj, {payment_value: paymentSelected, value: this.inputValueUser, payment_type: 'WALLET'})
                break
              case 'GOKWIKUPI' :
                Object.assign(upiObj, {payment_value: paymentSelected, value: this.inputValueUser, payment_type: 'UPI'})
                break
              default:
                console.error('Error')
            }
          }
          return {
            upiObj, paymentSelected
          }
        })
      },
      imgHighlightHandler (e) {
        this.imgHighLight = e && e.target && e.target.value
      }
    },
    created () {
      var b = $(window).width()
      if (b < 991) {
        this.isDesktop = false
      } else {
        this.isDesktop = true
      }
      if (b < 450) {
        this.isxsMobile = true
      } else {
        this.isxsMobile = false
      }
    },
    mounted () {
      var b = $(window).width()
      if (b < 991) {
        this.isDesktop = false
      } else {
        this.isDesktop = true
      }
      if (b < 450) {
        this.isxsMobile = true
      } else {
        this.isxsMobile = false
      }
    },
    computed: {
      ...mapGetters(['upis', 'bannerPlcaeHolderData', 'payMethodsOutage']),
      bannerPlaceHolderWithoutUpiWeb: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'UPI_WEB'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      upiOutageData () {
        const upidata = this.payMethodsOutage && this.payMethodsOutage.filter(itm => itm.payment_method_type === 'UPI' && itm.payment_method === 'UPI')
        let upiExtracteddata = upidata && upidata.length ? upidata[0] : {}
        if (upiExtracteddata && Object.keys(upiExtracteddata).length) {
          return this.upis && this.upis.map((upiItm) => {
            let specificData = upiExtracteddata.sub_details && upiExtracteddata.sub_details.filter(subData => subData.upi_app === upiItm.upi_app)
            specificData && specificData.length ? upiItm['isOutageApplicable'] = specificData[0].status : upiItm['isOutageApplicable'] = upiExtracteddata.status
            return upiItm
          })
        }
        return this.upis
      },
      bannerPlaceHolderFoPayMethodFluctuating () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_FLUCTUATING'.toLowerCase())
      },
      bannerPlaceHolderFoPayMethodDown () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_DOWN'.toLowerCase())
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 6px;
  margin-top: 4px;
}

.radio-item input[type='radio'] {
  display: none;
}

.radio-item label {
  color: #666;
  font-weight: normal;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 18px;
  height: 18px;
  border-radius: 11px;
  border: 2px solid #ccc;;
  background-color: transparent;
  cursor: pointer;
}
.radio-item input[type=radio]:checked + label:before {
  border: 2px solid #117a7a !important;
}
.radio-item input[type=radio]:checked + label:after {
  border-radius: 11px;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 9px;
  left: 10px;
  content: " ";
  display: block;
  background: #117a7a;
  cursor: pointer;
}
.image-wrapper-highlight {
  border: 3px solid #117a7a !important;
}
.num65{width:200px}
  .wallet {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .custom-control-input-tapan{border-color: aqua;width: 18px;height: 18px;}
  .phone8898{display: flex;}
  .phone8898 .num65{margin-right: 10px;}
  .left_img65 span{ color:#58595b}
  .wal15{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
  .left_img65{display: flex;  align-items: center;}
  .text-box {
    margin: 3% 5% 2% 5%;
    max-width: 80%;
  }
  .form-control {
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
  }
  .content {
    margin: 0;
    padding-top: 0px;
  }


  .wallet {
    padding: 0;
    text-align: center;
    margin-bottom:25px;
  }

  .custom-control {
    margin-right: 0;
  }

  .image-wrapper {
    border:0;
    border-radius: 50%;
    padding:0px;
    margin: 0;
    width: 40px;
    height:40px;
    margin-right: 18px;
    box-shadow: 0 0 5px #d9caca;           
    overflow: hidden;
  }

  .image-wrapper:hover,
  input[type="radio"]:checked + .image-wrapper {
    border-color: #ed2e30;
  }

  .form-check-label {
    padding: 0 20px;
    width:100%
  }

  img {
    width: 700px;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  .upi-fail-msg {
    color: rgb(196, 147, 150);
    font-size: 14px;
    padding: 0 25px;
  }

  .upi-message {
    padding: 5px 15px;
    white-space: normal;
  }

  .waltcol026{width:100%}


 @media screen and (max-width: 767px) {
  .wallet{display: block;}
  .waltcol026{display: flex;}
  .num65 {
    width: 90%;
    margin: 0 auto;
  }
  .wal15{width:100%; padding: 0 10px;}
 }

  

  @media screen and (max-width: 991px) {
    .form-check-label {
      padding: 0;
    }
    .upi-fail-msg {
      padding: 0;
      font-size: 13px;
    }
  }

  @media (min-width: 991px) {
    .col-lg-2 {
      width: 12%;
    }

    .wallet {
      margin-right: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// upiInput.vue?e248a7aa